// Resolves only CID 2 files that belong to the service(s) represented by an audit stage.
// Keeping this separate makes stage cards safe for grouped methodology scopes as well.
export const getCid2DocumentsForStage = (salesPackDocuments, salesPackServiceIds) => {
  const serviceIds = new Set(
    (Array.isArray(salesPackServiceIds) ? salesPackServiceIds : [])
      .map((id) => Number(id))
      .filter((id) => Number.isFinite(id))
  );

  if (serviceIds.size === 0) return [];

  return (Array.isArray(salesPackDocuments) ? salesPackDocuments : [])
    .filter((section) => serviceIds.has(Number(section?.serviceId)))
    .flatMap((section) => Array.isArray(section?.cid2) ? section.cid2 : []);
};
